import React from 'react';
import dollars from '../../dollar-format';
import {renderPrintFooter} from "../../utils";
import {executeQuery} from "../../requests/executeQuery";
import {STRIVE_INVENTORY_V2,STRIVE_INVENTORY_V3,STRIVE_INVENTORY_BREAKDOWN_V1} from '../../consts/queries';
import { ApolloConsumer } from '@apollo/client';
import { GET_STRIVE_INVENTORY_BREAKDOWN_V1, GET_STRIVE_INVENTORY_V2, GET_STRIVE_INVENTORY_V3 } from '../Graphql/Queries/InventoryQuery';
import { fetchData } from '../Service/graphQlService';

export default class Inventory extends React.Component {
	constructor(props) {
	    super(props);
		this.state = {
            rows: {
                STNL: {},
                MT: {},
                Other: {},
                Total: {}            
            },
            breakdownRows: {
                Retail: {},
                Office: {},
                Industrial: {},
                Apartments: {},
                BreakdownTotal: {}
            },
            isPrint: false,
            printBackground: '',
		};

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
	}

    static buildRowData(data, type) {
        const totalProperties = parseInt(data.TOTAL_PROPERTIES);
        const totalFee = parseFloat(data.TOTAL_FEE);
        const aveGrossFee = totalFee / totalProperties;
        return {
            type: type,
            properties: totalProperties,
            totalPrice: parseFloat(data.TOTAL_PRICE),
            totalFee: totalFee,
            aveGrossFee: aveGrossFee,
            aveNetFee: aveGrossFee / 2,
        };
    }

    static buildTotalData(rows) {
	    const dataToSum = {...rows};
        delete dataToSum.Total;

        Object.keys(dataToSum).forEach(key => {
            if (!dataToSum[key].properties) delete dataToSum[key];
        });

        const properties =  Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].properties, 0);
	    const totalPrice = Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].totalPrice, 0);
	    const totalFee = Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].totalFee, 0);
	    const aveGrossFee = totalFee / properties;

        return {
            type: 'Total',
            properties: properties,
            totalPrice: totalPrice,
            totalFee: totalFee,
            aveGrossFee: aveGrossFee,
            aveNetFee: aveGrossFee / 2,
        };
    }

    static buildBreakdownRowData(data, category) {
         const totalBreakdownProperties = parseInt(data.TOTAL_PROPERTIES);
        const totalBreakdownFee = parseFloat(data.TOTAL_FEE);
        const aveBreakdownGrossFee = totalBreakdownFee / totalBreakdownProperties;
        return {
            category: category,
            breakdownProperties: totalBreakdownProperties,
            totalBreakdownPrice: parseFloat(data.TOTAL_PRICE),
            totalBreakdownFee: totalBreakdownFee,
            aveBreakdownGrossFee: aveBreakdownGrossFee,
            aveBreakdownNetFee: aveBreakdownGrossFee / 2,
        };
    }
    static buildBreakdownTotalData(breakdownRows) {
        const dataToSum = {...breakdownRows};
        delete dataToSum.BreakdownTotal;

        Object.keys(dataToSum).forEach(key => {
            if (!dataToSum[key].breakdownProperties) delete dataToSum[key];
        });

        const breakdownProperties =  Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].breakdownProperties, 0);
	    const totalBreakdownPrice = Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].totalBreakdownPrice, 0);
	    const totalBreakdownFee = Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].totalBreakdownFee, 0);
	    const aveBreakdownGrossFee = totalBreakdownFee / breakdownProperties;

        return {
            category: 'Total',
            breakdownProperties: breakdownProperties,
            totalBreakdownPrice: totalBreakdownPrice,
            totalBreakdownFee: totalBreakdownFee,
            aveBreakdownGrossFee: aveBreakdownGrossFee,
            aveBreakdownNetFee: aveBreakdownGrossFee / 2,
        };
    }

	fetch() {
        const token = localStorage.getItem('authToken');
        // Promise.all([
        //     executeQuery({queryName: STRIVE_INVENTORY_V2, params: {TYPE: 'STNL'}}),
        //     executeQuery({queryName: STRIVE_INVENTORY_V2, params: {TYPE: 'MT'}}),
        //     executeQuery({queryName: STRIVE_INVENTORY_V3, params: {TYPE: 'Other'}}),
        //     executeQuery({queryName: STRIVE_INVENTORY_BREAKDOWN_V1, params: {CATEGORY: 'Retail'}}),
        //     executeQuery({queryName: STRIVE_INVENTORY_BREAKDOWN_V1, params: {CATEGORY: 'Office'}}),
        //     executeQuery({queryName: STRIVE_INVENTORY_BREAKDOWN_V1, params: {CATEGORY: 'Industrial'}}),
        //     executeQuery({queryName: STRIVE_INVENTORY_BREAKDOWN_V1, params: {CATEGORY: 'Apartments'}}),
            
        // ]).then(res => {
            if(this.client){
                Promise.all([
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_V2, variables: {params : {TYPE: 'STNL'}}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_V2, variables: {params : {TYPE: 'MT'}}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_V3, variables: {params : {TYPE: 'Other'}}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_BREAKDOWN_V1, variables: {params : {CATEGORY: 'Retail' }}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_BREAKDOWN_V1, variables: {params : {CATEGORY: 'Office'}}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_BREAKDOWN_V1, variables: {params : {CATEGORY: 'Industrial'}}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STRIVE_INVENTORY_BREAKDOWN_V1, variables: {params : {CATEGORY: 'Apartments'}}, fetchPolicy: "no-cache",
                //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // })

                fetchData( GET_STRIVE_INVENTORY_V2,  {params : {TYPE: 'STNL'}}),
                fetchData( GET_STRIVE_INVENTORY_V2,  {params : {TYPE: 'MT'}}),
                fetchData( GET_STRIVE_INVENTORY_V3,{params : {TYPE: 'Other'}}),
                fetchData( GET_STRIVE_INVENTORY_BREAKDOWN_V1,  {params : {CATEGORY: 'Retail' }}),
                fetchData( GET_STRIVE_INVENTORY_BREAKDOWN_V1, {params : {CATEGORY: 'Office'}}),
                fetchData( GET_STRIVE_INVENTORY_BREAKDOWN_V1, {params : {CATEGORY: 'Industrial'}}),
                fetchData( GET_STRIVE_INVENTORY_BREAKDOWN_V1, {params : {CATEGORY: 'Apartments'}})
            ]).then(res => {
            if (
                res && res[0] && Array.isArray(res[0].data.striveInventoryV2.data) && res[0].data.striveInventoryV2.data.length &&
                res[1] && Array.isArray( res[1].data.striveInventoryV2.data) &&  res[1].data.striveInventoryV2.data.length &&
                res[2] && Array.isArray( res[2].data.striveInventoryV3.data) &&  res[2].data.striveInventoryV3.data.length &&
                res[3] && Array.isArray(res[3].data.striveInventoryBreakdownV1.data) && res[3].data.striveInventoryBreakdownV1.data.length &&
                res[4] && Array.isArray(res[4].data.striveInventoryBreakdownV1.data) && res[4].data.striveInventoryBreakdownV1.data.length &&
                res[5] && Array.isArray(res[5].data.striveInventoryBreakdownV1.data) && res[5].data.striveInventoryBreakdownV1.data.length &&
                res[6] && Array.isArray(res[6].data.striveInventoryBreakdownV1.data) && res[6].data.striveInventoryBreakdownV1.data.length
             ) {
                const rows = {...this.state.rows};
                const breakdownRows = {...this.state.breakdownRows};
                const stnlData = res[0].data.striveInventoryV2.data[0];
                const mtData = res[1].data.striveInventoryV2.data[0];
                const otherData = res[2].data.striveInventoryV3.data[0];
                const retailData = res[3].data.striveInventoryBreakdownV1.data[0];
                const officeData = res[4].data.striveInventoryBreakdownV1.data[0];
                const industrialData = res[5].data.striveInventoryBreakdownV1.data[0];
                const apartmentsData = res[6].data.striveInventoryBreakdownV1.data[0];

                rows.STNL = Inventory.buildRowData(stnlData, 'STNL');
                rows.MT = Inventory.buildRowData(mtData, 'MT');
                rows.Other = Inventory.buildRowData(otherData, 'Other');
                rows.Total = Inventory.buildTotalData(rows);
                breakdownRows.Retail = Inventory.buildBreakdownRowData(retailData, 'Retail');
                breakdownRows.Office = Inventory.buildBreakdownRowData(officeData, 'Office');
                breakdownRows.Industrial = Inventory.buildBreakdownRowData(industrialData, 'Industrial');
                breakdownRows.Apartments = Inventory.buildBreakdownRowData(apartmentsData, 'Apartments');
                breakdownRows.BreakdownTotal = Inventory.buildBreakdownTotalData(breakdownRows);
                this.setState({rows});
                this.setState({breakdownRows})
            }
        })
         };
	}

	componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
	}

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

	render() {
        const {rows,breakdownRows, isPrint, printBackground} = this.state;
        const d = new Date();
		const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

		return (
        <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                    this.fetch(this.props.location.query);
                }
                return (

            <div className='Inventory'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className="Inventory_head_left">
                        <h3 className='Inventory_h3'>STRIVE Inventory</h3>
                        <h4 className='Inventory_h4'>{date}</h4>
                    </div>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th className="Inventory_th">Category</th>
                            <th className="Inventory_th"># of Active Properties</th>
                            <th className="Inventory_th">Total Price</th>
                            <th className="Inventory_th">Total Fee</th>
                            <th className="Inventory_th">Ave Gross Fee</th>
                            <th className="Inventory_th">Ave Net Fee</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            Object.keys(breakdownRows).map((key, index) => {
                                return (
                                    <tr key={key} className={index === Object.keys(breakdownRows).length - 2 ? "Inventory_total" : ''}>
                                        <td className="Inventory_td">{breakdownRows[key].category}</td>
                                        <td className="Inventory_column_numeric">{breakdownRows[key].breakdownProperties}</td>
                                        <td className="Inventory_column_numeric">{breakdownRows[key].totalBreakdownPrice ? dollars(breakdownRows[key].totalBreakdownPrice) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{breakdownRows[key].totalBreakdownFee ? dollars(breakdownRows[key].totalBreakdownFee, true) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{breakdownRows[key].aveBreakdownGrossFee ? dollars(breakdownRows[key].aveBreakdownGrossFee, true) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{breakdownRows[key].aveBreakdownNetFee ? dollars(breakdownRows[key].aveBreakdownNetFee, true) : '$0'}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>




                    <table className='table'>
                        <thead>
                        <tr>
                            <th className="Inventory_th">Type</th>
                            <th className="Inventory_th"># of Active Properties</th>
                            <th className="Inventory_th">Total Price</th>
                            <th className="Inventory_th">Total Fee</th>
                            <th className="Inventory_th">Ave Gross Fee</th>
                            <th className="Inventory_th">Ave Net Fee</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            Object.keys(rows).map((key, index) => {
                                return (
                                    <tr key={key} className={index === Object.keys(rows).length - 2 ? "Inventory_total" : ''}>
                                        <td className="Inventory_td">{rows[key].type}</td>
                                        <td className="Inventory_column_numeric">{rows[key].properties}</td>
                                        <td className="Inventory_column_numeric">{rows[key].totalPrice ? dollars(rows[key].totalPrice) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{rows[key].totalFee ? dollars(rows[key].totalFee, true) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{rows[key].aveGrossFee ? dollars(rows[key].aveGrossFee, true) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{rows[key].aveNetFee ? dollars(rows[key].aveNetFee, true) : '$0'}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
            	)
            }}

        </ApolloConsumer>
		);
	}
}
